import { useLayoutEffect } from 'react';

/**
 * Snap the document back to the top whenever `key` changes.
 *
 * The app swaps page content in place — wizard steps, top-level views, admin
 * panels — without a browser navigation, so the document keeps whatever scroll
 * offset the previous content left behind. On a phone that lands the user
 * halfway down the new page.
 *
 * useLayoutEffect (not useEffect) so the jump happens before paint and no
 * wrong position is ever visible. Instant, never smooth: animating a scroll
 * across content that has just been replaced reads as a glitch.
 */
export function useScrollToTop(key: unknown): void {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [key]);
}
